import React from 'react';

import * as ST from './styled';

const Description = ({ title, price }) => {
    const textAfter = price
        ? <>Через месяц услуга продлится автоматически.</>
        : <>Услуга будет автоматически входить в ваш тариф до тех пор, <br/>
            пока вы остаетесь нашим клиентом.</>;

    return (
        <ST.Paragraph>
            <ST.Text>
                Вы выбрали тариф <ST.TextBold>«{title}»</ST.TextBold>.
                Он стоит <ST.TextBold>{price} ₽ в месяц</ST.TextBold>. <br/>
                {textAfter}
            </ST.Text>
        </ST.Paragraph>
    );

};

export default Description;
